import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/RetiredComponents/navigation-components/nav-bar-top.css'
import './components/RetiredComponents/searching-components/search-bar.css'
import './components/RetiredComponents/searching-components/search-side-bar.css'
import './components/RetiredComponents/shop-components/product-box.css'
import './components/RetiredComponents/shop-components/product-header.css'
import './components/navigation-components-blog/topbar.scss'
import './components/blog-header/blogheader.scss'

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
